import React, { useState, useEffect } from 'react'

import {
	Button,
	Dialog,
	DialogTitle,
	DialogContent,
	DialogActions,
	MenuItem,
	TextField,
	Typography
} from '@material-ui/core'

import { makeStyles } from '@material-ui/core/styles'

import { useSelector } from 'react-redux'

const useStyles = makeStyles((theme) => ({
	dialogActions: {
		justifyContent: 'flex-start'
	},
	serviceWrapper: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'space-between',
		marginBottom: 27,
		'& p': {
			width: '50%'
		}
	},
	fieldWrapper: {
		minWidth: '400px !important',
		width: '400px !important',
		marginBottom: 36,
		'& .MuiFilledInput-root': {
			minWidth: '400px !important',
			width: '400px !important'
		},
		'& .MuiTextField-root': {
			minWidth: '400px !important',
			width: '400px !important'
		}
	},
	disableButton: {
		color: '#D02C2C',
		fontSize: '14px',
		lineHeight: '19px',
		borderRadius: '25px',
		marginBottom: 32,
		'&:hover': {
			backgroundColor: 'rgba(208, 44, 44, 0.2)'
		}
	},
	close: {
		position: 'absolute',
		top: 10,
		right: 10,
		padding: 10,
		fontFamily: 'Nunito',
		fontWeight: '800',
		fontSize: 12,
		cursor: 'pointer'
	}
}))

const AutoRefillDialog = (props) => {
	const classes = useStyles()
	const selected = useSelector((state) => state.specific.households.selected)

	let { selectedCredit, isShown, setIsShown, updateAutoRenew, removeAutoRenew } = props

	const [creditQuantityOptions, setCreditQuantityOptions] = useState([])
	const [credit, setCredit] = useState(selectedCredit)

	useEffect(() => {
		if (selectedCredit) {
			setCredit({ ...selectedCredit })

			if (selectedCredit.type === 'daycare') {
				setCreditQuantityOptions([1, 5, 20, 50])
			} else {
				setCreditQuantityOptions([1, 5, 15])
			}
		}
	}, [selectedCredit])

	return (
		<Dialog
			open={isShown}
			aria-labelledby="form-dialog-title"
			className={classes.dialog}
			onClose={() => setIsShown(false)}
			PaperProps={{
				style: {
					minWidth: '448px',
					maxWidth: '448px',
					width: '448px'
				}
			}}>
			<DialogTitle>AUTO REFILL</DialogTitle>
			<DialogContent>
				<span className={classes.close} onClick={() => setIsShown(false)}>
					X
				</span>
				<div className={classes.serviceWrapper}>
					<Typography variant="overline" style={{ textTransform: 'none' }}>
						Service
					</Typography>
					<Typography variant="body2">{credit ? credit.service : ''}</Typography>
				</div>
				<div className={classes.fieldWrapper}>
					<TextField
						select
						label="Quantity"
						variant="filled"
						value={credit && credit.autoRefillAmount ? credit.autoRefillAmount : ''}
						onChange={(e) => setCredit({ ...credit, autoRefillAmount: e.target.value })}>
						{creditQuantityOptions.map((creditQuantityOption) => (
							<MenuItem key={creditQuantityOption} value={creditQuantityOption}>
								{`${creditQuantityOption} Credits`}
							</MenuItem>
						))}
					</TextField>
				</div>
				{credit && credit.autoRefillAmount && selected.auto_renew && selected.auto_renew[credit.type] ? (
					<Button
						onClick={() => {
							setCredit({ ...credit, autoRefillAmount: 0 })
							removeAutoRenew(credit)
						}}
						className={classes.disableButton}>
						Disable Auto Refill
					</Button>
				) : null}
			</DialogContent>
			<DialogActions className={classes.dialogActions}>
				<Button variant="contained" onClick={() => updateAutoRenew(credit)} color="secondary">
					SAVE
				</Button>
				<Button variant="outlined" onClick={() => setIsShown(false)} color="secondary">
					CANCEL
				</Button>
			</DialogActions>
		</Dialog>
	)
}

export default AutoRefillDialog
